import axios from '@/utils/axios'
// import qs from 'qs';
// 设置默认请求头（可以在应用初始化时设置一次）
axios.defaults.headers.post['Content-Type'] = 'application/json';


export default {
    /**
     * 获取消息列表
     * @param {*} data 
     * @returns 
     */
    getMessageList: async (data) => {
        try {
            axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
            const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/user/message/page`,
                {
                    params: data,
                    headers: {
                        token: sessionStorage.getItem('token')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log(error)
        }
    },
    /**
     * 修改消息可读状态
     * @param {*} data 
     * @returns 
     */
    messageUpdateRead: async (data) => {
        try {
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/user/message/updateRead`,
                data,
                {
                    headers: {
                        token: sessionStorage.getItem('token')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log(error)
        }
    },
    /**
     * 批量删除消息
     * @param {*} data 
     * @returns 
     */
    deleteMessage: async (data) => {
        try {
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            const response = await axios.post(`${process.env.VUE_APP_BASE_API}/spectral-api/api/user/message/deleted`,
                data,
                {
                    headers: {
                        token: sessionStorage.getItem('token')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log(error)
        }
    },
    /**
     * 获取未读消息数量
     * @returns 
     */
    unReadCount: async () => {
        try {
            axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
            const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/user/message/unReadCount`,
                {
                    headers: {
                        token: sessionStorage.getItem('token')
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log(error)
        }
    },
}